import type { SiteConfig } from '../../@types/context/site-config.types';
import { insuranceMypageSe } from './insurance-mypage.config';

export const sitePathZmartaSeConfig: Pick<SiteConfig, 'path'> = {
  path: {
    loansApply: '/lana-pengar/privatlan/laneansokan',
    mypage: '/mina-sidor/privatlan',
    mypageOverview: '/mina-sidor',
    mypageLoans: '/mina-sidor/privatlan',
    oneFormPreflight: '/ansokan/identifiering',
    oneFormApply: '/ansokan/lan',
    oneFormRecommendations: '/ansokan/lan/rekommendationer',
    insurance: '/ansokan/forsakring',
    ...insuranceMypageSe,
  },
};
